import { render } from "./TotalOrdersChartTwo.vue?vue&type=template&id=684d0ae5&ts=true"
import script from "./TotalOrdersChartTwo.vue?vue&type=script&lang=ts"
export * from "./TotalOrdersChartTwo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__